export const isNodeRoot = ({ menu, nodeId }) => menu.id === nodeId;

export const findNodeParent = ({ menu, node, parent = null }) => {
  if (!node) {
    return null;
  }
  menu.children?.forEach((ch) => {
    if (ch.id === node.id) {
      parent = menu;
    } else {
      parent = findNodeParent({ menu: ch, node, parent });
    }
  });
  return parent;
};

export const findNodeById = ({ menu, nodeId, id = null }) => {
  if (!nodeId) {
    return null;
  }

  if (menu.id === nodeId) {
    return menu;
  }

  menu.children?.forEach((ch) => {
    if (ch.id === nodeId) {
      id = ch;
    } else {
      id = findNodeById({ menu: ch, nodeId, id });
    }
  });
  return id;
};

export const findNodeByUri = ({ menu, nodeUri, uri = null }) => {
  if (!nodeUri) {
    return null;
  }

  if (menu.subject.uri === nodeUri) {
    return menu;
  }

  menu.children?.forEach((ch) => {
    if (ch.subject.uri === nodeUri) {
      uri = ch;
    } else {
      uri = findNodeByUri({ menu: ch, nodeUri, uri });
    }
  });
  return uri;
};

// ******* UPDATE NODE**************************/

const buildWbTreeChildrenByNode = ({ menu, node }) => {
  menu.children.forEach((ch, index) => {
    if (ch.children && Array.isArray(ch.children) && ch.children.length) {
      buildWbTreeChildrenByNode({
        menu: menu.children[index],
        node,
      });
    }
    if (ch.id === node.id) {
      menu.children[index] = node;
    }
  });

  return menu;
};

export const buildWbTreeByNode = ({ wbTree, node }) => {
  if (node.id === wbTree.menu.id) {
    return { ...wbTree, menu: node };
  }

  const menu = buildWbTreeChildrenByNode({
    menu: JSON.parse(JSON.stringify(wbTree.menu)),
    node,
  });

  return { ...wbTree, menu };
};

const buildWbTreeChildrenByNodeUri = ({ menu, node }) => {
  menu.children.forEach((ch, index) => {
    if (ch.children && Array.isArray(ch.children) && ch.children.length) {
      buildWbTreeChildrenByNodeUri({
        menu: menu.children[index],
        node,
      });
    }
    if (ch.subject.uri === node.subject.uri) {
      menu.children[index] = node;
    }
  });

  return menu;
};

export const buildWbTreeByNodeUri = ({ wbTree, node }) => {
  if (node.subject.uri === wbTree.menu.subject.uri) {
    return { ...wbTree, menu: node };
  }

  const menu = buildWbTreeChildrenByNodeUri({
    menu: JSON.parse(JSON.stringify(wbTree.menu)),
    node,
  });

  return { ...wbTree, menu };
};

// *************** ADD NODE ************************** //
const buildWbTreeAddingNode = ({ menu, node, addNodeFrom }) => {
  menu.children.forEach((ch, index) => {
    if (ch.children && Array.isArray(ch.children) && ch.children.length) {
      buildWbTreeAddingNode({
        menu: menu.children[index],
        node,
        addNodeFrom,
      });
    }
    if (ch.id === addNodeFrom.id) {
      menu.children[index] = {
        ...ch,
        children: ch?.children ? [...ch.children, node] : [node],
      };
    }
  });

  return menu;
};

export const addNodeToWbTree = ({ wbTree, node, addNodeFrom }) => {
  if (addNodeFrom.id === wbTree.menu.id) {
    return {
      ...wbTree,
      menu: {
        ...wbTree.menu,
        children: [...wbTree.menu.children, node],
      },
    };
  }

  const menu = buildWbTreeAddingNode({
    menu: JSON.parse(JSON.stringify(wbTree.menu)),
    node,
    addNodeFrom,
  });

  return { ...wbTree, menu };
};

// *************** REMOVE NODE ************************** //

// Returns an array with children or undefined. Empty array is not valid for the API
const getChildrenForRemoveNode = ({ ch, node }) => {
  const res = ch?.children?.filter((c) => c.id !== node.id);
  return res?.length ? res : undefined;
};

const buildWbTreeRemovingNode = ({ menu, node, removeNodeFrom }) => {
  menu.children.forEach((ch, index) => {
    if (ch.children && Array.isArray(ch.children) && ch.children.length) {
      buildWbTreeRemovingNode({
        menu: menu.children[index],
        node,
        removeNodeFrom,
      });
    }
    if (ch.id === removeNodeFrom.id) {
      menu.children[index] = {
        ...ch,
        children: getChildrenForRemoveNode({ ch, node }),
      };
    }
  });

  return menu;
};

export const removeNodeFromWbTree = ({ wbTree, node, removeNodeFrom }) => {
  if (removeNodeFrom.id === wbTree.menu.id) {
    return {
      ...wbTree,
      menu: {
        ...wbTree.menu,
        children: getChildrenForRemoveNode({ ch: wbTree.menu, node }),
      },
    };
  }
  const menu = buildWbTreeRemovingNode({
    menu: JSON.parse(JSON.stringify(wbTree.menu)),
    node,
    removeNodeFrom,
  });

  return { ...wbTree, menu };
};

// ---------------------------------- //

export const buildPlainNodesfromMenu = ({
  menu,
  init = false,
  plainNodes = [],
}) => {
  if (init) {
    plainNodes.push(menu);
  }
  menu.children?.forEach((ch, index) => {
    if (ch.children && Array.isArray(ch.children) && ch.children.length) {
      buildPlainNodesfromMenu({
        menu: menu.children[index],
        plainNodes,
      });
    }
    plainNodes.push(ch);
  });

  return plainNodes;
};

export const addWarnings = (validationResults) => {
  let warningMessage = '';
  if (validationResults.warnings.length) {
    warningMessage +=
      '<p>There are some non-critical issues that should be fixed:</p><ul>';
    for (const msg of validationResults.warnings) {
      warningMessage += `<li>${msg}</li>`;
    }
    warningMessage += '</ul>';
  }
  return warningMessage;
};

export const getDepth = (tree, id, depth = 0) => {
  const target = tree.find((node) => node.id === id);

  if (target) {
    return getDepth(tree, target.parent, depth + 1);
  }

  return depth;
};
